import { createPortalHeader } from "../../admin-shared/PortalHeader";
import { useUser } from "../context/UserContext";
import { permissionService } from "../services/permissionService";
import { API_BASE, clearPortalStorage, PORTAL_ID } from "../utils/api";
import { loginPathForRole } from "../utils/loginPaths";
import { ENTERPRISE_DEFAULT_ORG_LOGO, resolveMediaUrl, resolveStoredOrgLogo } from "../utils/mediaUrl";
import {
  applyThemeToDocument,
  getStoredTheme,
  THEME_STORAGE_KEY,
} from "../utils/theme";
import { fetchCheckinQueue } from "../utils/checkinQueueApi";
import PassportHeaderToolbar from "./PassportHeaderToolbar";

const Header = createPortalHeader({
  portalId: PORTAL_ID,
  portalBasePath: "/nyafaz-ep/partner",
  editProfilePath: "/nyafaz-ep/partner/edit-profile",
  extraProfileLinks: [
    {
      label: "Device login & password",
      path: "/nyafaz-ep/partner/kiosk-login",
      show: () => permissionService.isFranchise(),
    },
  ],
  useUser,
  API_BASE,
  clearPortalStorage,
  loginPathForRole,
  resolveMediaUrl,
  resolveStoredOrgLogo,
  logoFallback: ENTERPRISE_DEFAULT_ORG_LOGO,
  applyThemeToDocument,
  getStoredTheme,
  THEME_STORAGE_KEY,
  fetchCheckinQueue,
  renderToolbar: () => <PassportHeaderToolbar />,
});

export default Header;
